import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterIdsArraySearchValueObject} from './FilterIdsArraySearchValueObject.js'

export class FilterColorIdsSearchValueObject extends ValueObject {
  #colorIds

  constructor({colorIds}) {
    super()
    this.#colorIds = colorIds
  }

  static create({colorIds}) {
    return new FilterColorIdsSearchValueObject({colorIds: FilterIdsArraySearchValueObject.create(colorIds)})
  }

  static createWithDefaultValue({config, colorIds}) {
    const {DEFAULT_COLOR_IDS_SEARCH} = config.get('searchFilters')

    return new FilterColorIdsSearchValueObject({
      colorIds: FilterIdsArraySearchValueObject.createForNumbers({value: colorIds ?? DEFAULT_COLOR_IDS_SEARCH})
    })
  }

  static createQueryParams({config, colorIds}) {
    const {DEFAULT_COLOR_IDS_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterColorIdsSearchValueObject({
      colorIds: QueryParamSharedValueObject.createForPipeArray({
        key: FILTER_QUERY_PARAMS[FILTER_NAMES.COLOR],
        value: colorIds ?? DEFAULT_COLOR_IDS_SEARCH
      })
    })
  }

  get isEmpty() {
    return this.#colorIds.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.isEmpty && {...this.#colorIds.queryParam})
    }
  }

  get value() {
    return this.#colorIds.value
  }

  toJSON() {
    return {
      colorIds: this.#colorIds.toJSON()
    }
  }
}
